import { TextTestID } from "@/constants/TestID";
import { FAIconName, Icon, Text } from "@/ui/core";
import { Box, HStack } from "@/ui/layout";
import { ColorToken, LayoutToken } from "@/ui/theme/tokens";
import { isWeb } from "@/utils/platform.util";
import { joinTestIDs } from "@/utils/string.util";

interface VideoPlayerCardControlsProps extends ViewWithTestID {
  isPlaying?: boolean;
  onControlPress?: () => Promise<void> | void;
  title?: string;
}

const VideoPlayerCardControl = ({
  isPlaying = false,
  onControlPress,
  testID,
  title,
}: VideoPlayerCardControlsProps) => {
  const iconTestID = isPlaying ? `${testID}-pause` : `${testID}-play`;
  return (
    <HStack
      alignItems="center"
      bottom={20}
      gap={6}
      justifyContent="space-between"
      paddingHorizontal={24}
      testID={testID}
      width="100%"
    >
      <Box
        padding={isWeb() ? LayoutToken.OnboardingScreenHorizontalPadding : 0}
      >
        <Text
          color={ColorToken.NeutralBackgroundPrimary}
          testID={joinTestIDs(testID, TextTestID.Title)}
          variant="bodyMedium"
        >
          {title || ""}
        </Text>
      </Box>
      <Box
        alignItems="center"
        backgroundColor={ColorToken.AccentBlue}
        borderRadius={18}
        height={36}
        justifyContent="center"
        onPress={() => void onControlPress?.()}
        width={36}
      >
        <Icon
          color="white"
          name={isPlaying ? FAIconName.Pause : FAIconName.Play}
          size="sm"
          testID={iconTestID}
        />
      </Box>
    </HStack>
  );
};
export type { VideoPlayerCardControlsProps };
export default VideoPlayerCardControl;
